module.exports = __webpack_public_path__ + "img/logo.b0e29ccd.png";